/**
 * Shared UI component for UI Badge.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';
import { UiBadgeTone } from './ui-badge.types';

/**
 * COMPONENT: Ui Badge
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-badge',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-badge.component.html',
  styleUrl: './ui-badge.component.scss'
})
export class UiBadgeComponent {
  /** PARENT-CHILD CONTRACT: label documents the input state boundary used by this file. */
  readonly label = input('');
  readonly tone = input<UiBadgeTone>('active');
}
